<script>
  import { createEventDispatcher } from 'svelte';

  import { InlineNotification, Modal } from 'carbon-components-svelte';

  import LoadingSpinner from '../LoadingSpinner.svelte';
  import { removeBuildParameter } from '../../services';

  export let entityType,
    entityName,
    targetName,
    open = false,
    parameter;

  let loading = false;
  let resultNotification;

  const dispatch = createEventDispatcher();

  async function removeParameter() {
    loading = true;

    try {
      await removeBuildParameter(parameter.id);

      dispatch('close', { id: parameter.id, configId: parameter.configId });
    } catch (error) {
      console.error('[RemoveParameterModal] Failed to remove parameter!', error);
      resultNotification = {
        hideCloseButton: false,
        kind: 'error',
        title: 'Error:',
        subtitle: 'Failed to remove parameter! Please try again later.',
      };
    } finally {
      loading = false;
    }
  }

  function onModalClose() {
    dispatch('close');
  }
</script>

<Modal
  danger
  modalHeading="Remove Parameter"
  preventCloseOnClickOutside={true}
  primaryButtonText="Remove"
  secondaryButtonText="Cancel"
  size="sm"
  bind:open
  on:click:button--secondary={onModalClose}
  on:close={onModalClose}
  on:submit={removeParameter}
>
  <LoadingSpinner small {loading}>
    {#if resultNotification}
      <InlineNotification
        kind={resultNotification.kind}
        lowContrast
        title={resultNotification.title}
        subtitle={resultNotification.subtitle}
      />
    {/if}
    <p>
      You are about to remove parameter <strong>{parameter.parameterName}</strong>
      {#if targetName}
        from <strong>{targetName}</strong> target under <strong>{entityName}</strong> {entityType}.
      {:else}
        from {entityType} <strong>{entityName}</strong>.
      {/if}
      Are you sure?
    </p>
  </LoadingSpinner>
</Modal>
